module.exports = __webpack_public_path__ + "static/alex-prioni.003e82b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alex-prioni.png
// module id = 644
// module chunks = 169858455373905